import React from 'react'
import "./Home.css"
import myCv from "./cv.pdf"
import Typewriter from 'typewriter-effect';
import {BsFillMoonStarsFill,} from "react-icons/bs"
import {FiSun,} from "react-icons/fi"
import {Link} from 'react-scroll'
import Slide from 'react-reveal/Slide';

function Home({theme, changeTheme}) {
  return (
    <div className="container-fluid home" id='home'>

      <div className="theme-change" onClick={changeTheme}>
        {theme === "light" ? (<p><BsFillMoonStarsFill size={30}/></p>) : (<p className='sun-theme-icon'><FiSun size={30}/></p>)}
      </div>

      <div className="container home-content">
      <div>
        <Slide right>
        <h1>Hi I'm Abdirashid Kheyre</h1>
        </Slide>
      </div>
     
        <h3>
          <Typewriter
            options={{
              strings: ['MERN Stack Developer','UI/UX Designer', 'Mobile Developer', 'Video Editor'],
              autoStart: true,
              loop: true,
            
            }}
          />
        </h3>

        <div className="button-for-action">
         <Link 
         to='contactid'
         spy={true}
         smooth={true}
         duration={100}
         offset={-100}
         >
         <div className='hire-me-button'>Hire me</div>
         </Link>
          <div className='get-resume-button'><a href={myCv} download="Kheyre_Cv">Get Rusume</a></div>
        </div>
      </div>
    </div>
  )
}

export default Home